import { Center } from '@chakra-ui/react';
import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';

const SiteFooter = ({stateProps}) => {
  return (
    <Center pb={6}>
      <MobileFooter stateProps={stateProps} />
      <DesktopFooter stateProps={stateProps} />
    </Center>
  );
};
export default SiteFooter;
